module.exports = __webpack_public_path__ + "static/media/20ECE27.2f7c109d.jpg";